'use client'

import CssBaseline from '@mui/material/CssBaseline'
import { ThemeProvider } from '@mui/material/styles'

// Types
import type { MUIProviderProps } from '@/types/components/providers/mui'

// Configurations
import ThemeConfig from '@/config/theme'

const MUIProvider = (props: MUIProviderProps) => {
	// Props
	const { dir, children } = props

	return (
		<ThemeProvider theme={ThemeConfig(dir)}>
			<CssBaseline />
			{children}
		</ThemeProvider>
	)
}

export default MUIProvider
